import React, { Component } from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LayoutIcon, MousePointerClickIcon, MapPinIcon, CheckCircle2Icon } from 'lucide-react';
type PillarCardProps = {
  number: string;
  icon: ComponentType<any>;
  title: string;
  items: string[];
};
const PillarCard: React.FC<PillarCardProps> = ({
  number,
  icon: Icon,
  title,
  items
}) => <div className="glass-card p-5 sm:p-8 flex flex-col h-full relative overflow-hidden group" data-id="element-211">
    <div className="absolute -top-4 sm:-top-6 -right-4 sm:-right-6 text-7xl sm:text-9xl font-heading font-extrabold text-slate-900/5 select-none" data-id="element-212">
      {number}
    </div>

    <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-gold-500/15 flex items-center justify-center mb-4 sm:mb-6 border border-gold-500/30 relative z-10" data-id="element-213">
      <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-gold-600" data-id="element-214" />
    </div>

    <h3 className="text-lg sm:text-2xl font-bold text-slate-900 mb-3 sm:mb-6 relative z-10" data-id="element-215">
      {title}
    </h3>

    <ul className="space-y-2 sm:space-y-4 relative z-10 flex-1" data-id="element-216">
      {items.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-217">
          <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-500 shrink-0 mt-0.5" data-id="element-218" />
          <span className="text-xs sm:text-base text-slate-600 leading-relaxed" data-id="element-219">
            {item}
          </span>
        </li>)}
    </ul>
  </div>;
export function GrowthStrategy() {
  return <SlideLayout data-id="element-220">
      <div className="mb-6 sm:mb-12 text-center" data-id="element-221">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full mx-auto" data-id="element-222" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-223">
          Recommended Growth Strategy
        </h2>
        <p className="text-sm sm:text-xl text-slate-500 max-w-2xl mx-auto" data-id="element-224">
          A three-pillar approach to transform your website into a lead
          generation engine.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 items-stretch" data-id="element-225">
        <PillarCard number="01" icon={LayoutIcon} title="Site Structure & Service Pages" items={['Create dedicated mortgage service pages (refinancing, renewals, first-time buyer, pre-approval)', 'Build location-targeted landing pages for Kingston and surrounding areas', 'Map high-intent keywords to specific pages for maximum relevance', 'Redesign navigation around user intent and conversion paths']} data-id="element-226" />
        <PillarCard number="02" icon={MousePointerClickIcon} title="CRO & UX Improvements" items={['Add stronger CTAs: Apply Now, Get Pre-Approved, Book a Consultation', 'Improve page layouts for lead generation with trust signals and forms', 'Streamline the user journey from landing to inquiry', 'Add social proof, testimonials, and trust indicators']} data-id="element-227" />
        <PillarCard number="03" icon={MapPinIcon} title="Local SEO Expansion" items={['Optimize Google Business Profile with posts and updates', 'Build local citations and business listings', 'Create location-specific content targeting nearby communities', 'Develop local link building strategy']} data-id="element-228" />
      </div>

      <p className="mt-4 sm:mt-8 text-xs sm:text-sm text-slate-500 italic text-center" data-id="element-229">
        Note: This will require design + development support for proper
        implementation
      </p>
    </SlideLayout>;
}